import { h, Component } from 'preact';
import cx from 'classnames';
import dlv from 'dlv';

import style from './style';
import { configure } from '../../../config';
import pageStyles from '../pageStyles';

import { SadlibAd } from '../../pieces/sadlib-ad';
import { PromoBanner } from '../../pieces/promo-banner';
import { showPromo } from '../../../lib/promo';

import { Section } from '@cube/layout';
import { DesktopHeader, DesktopFooter, DesktopHeaderP25 } from '@cube/header-widget';

@configure([
	'singleCube.mastheadTheme'
])
export class Header extends Component {

	componentWillMount() {
		if (showPromo(dlv(this.props, 'pageConfig.promoBanner'))) {
			this.setState({
				showPromo: true
			});
		}
	}

	render({ pageConfig, adId, mastheadTheme, ...props }, { showPromo }) {
		if (pageConfig.mastheadTheme) mastheadTheme = pageConfig.mastheadTheme;

		return (
			<div class={style.headerWrapper}>
				{ !showPromo && adId &&
					<Section rowClass={cx(pageStyles.masthead, pageStyles[mastheadTheme])} containerClass={pageStyles.defaultPageWidth}>
						<SadlibAd id={adId} type="desktopMasthead" />
					</Section>
				}
				{ showPromo &&
					<PromoBanner config={pageConfig.promoBanner} />
				}
				<DesktopHeader
					{...pageConfig.header}
					{...props}
				/>
			</div>
		);
	}
}

@configure([
	'singleCube.mastheadTheme'
])
export class HeaderP25 extends Component {

	componentWillMount() {
		if (showPromo(dlv(this.props, 'pageConfig.promoBanner'))) {
			this.setState({
				showPromo: true
			});
		}
	}

	render({ pageConfig, adId, mastheadTheme, ...props }, { showPromo }) {
		if (pageConfig.mastheadTheme) mastheadTheme = pageConfig.mastheadTheme;

		return (
			<div class={style.headerWrapper}>
				{ !showPromo && adId &&
					<Section rowClass={cx(pageStyles.masthead, pageStyles[mastheadTheme])} containerClass={pageStyles.defaultPageWidth}>
						<SadlibAd id={adId} type="desktopMasthead" />
					</Section>
				}
				{ showPromo &&
					<PromoBanner config={pageConfig.promoBanner} />
				}
				<DesktopHeaderP25
					{...pageConfig.header}
					{...props}
				/>
			</div>
		);
	}
}

export const Footer = ({ pageConfig, ...props }) =>
	(
		<DesktopFooter
			class={pageStyles.footer}
			{...pageConfig.footer}
			{...props}
		/>
	);
